module.exports = __webpack_public_path__ + "static/img/DKP.c0bc801.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DKP.jpg
// module id = FwOy
// module chunks = 26